uniform float time;
uniform float progress;
uniform sampler2D texture1;
uniform vec4 resolution;
varying vec2 vUv;
varying vec3 vPosition;
varying float vColorRandom;
varying float vTouch;

uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;
uniform float uEmissionStrength;

void main() {
	float alpha = 1.0 - smoothstep(-0.2, 0.5, length(gl_PointCoord - vec2(0.5)));

	vec3 finalColor = uColor1;
	if (vColorRandom > 0.33 && vColorRandom < 0.66) {
		finalColor = uColor2;
	}
	if (vColorRandom > 0.66) {
		finalColor = uColor3;
	}

	float gradient = smoothstep(0.3, 0.7, vUv.y);

	// Hover glow — reuses the same touch trail as particle push
	vec3 glowTint = vec3(0.75, 0.5, 1.0);
	finalColor = mix(finalColor, glowTint, vTouch * 0.55);
	finalColor += finalColor * vTouch * uEmissionStrength;

	gl_FragColor = vec4(finalColor, alpha * gradient);
}
